import { useState } from 'react';
import Header from '../home/components/Header';
import Footer from '../home/components/Footer';
import ForumsHero from './components/ForumsHero';
import ForumCategories from './components/ForumCategories';
import TrendingTopics from './components/TrendingTopics';
import RecentDiscussions from './components/RecentDiscussions';

export default function Forums() {
  const [showRegistration, setShowRegistration] = useState(false);

  return (
    <div className="min-h-screen bg-gray-950">
      <Header onRegisterClick={() => setShowRegistration(true)} />
      <ForumsHero />
      <ForumCategories />
      <TrendingTopics />
      <RecentDiscussions />
      <Footer />
    </div>
  );
}
